// Configurazione del cassetto FWSSP probe.

export const FWSSP_PROBE = {
  // Interruttore generale: false = nessun invio dati (no-op totale).
  // Mettere a true SOLO durante una raccolta dati attiva.
  enabled: false,
  // URL del Realtime DB (senza slash finale). Vuoto = probe disattivato (no-op).
  // Per riattivare la raccolta: enabled = true e scommentare la riga sotto.
  // es: "https://<progetto>-default-rtdb.europe-west1.firebasedatabase.app"
  dbUrl: "",
  //dbUrl: "https://test-fd12b-default-rtdb.europe-west1.firebasedatabase.app",
  // 1 = tutte le impression; abbassa (es. 0.2) per ridurre ancora il traffico.
  sampleRate: 1,
  // Progressivo esperimento: isola i dati di ogni run sotto /fwssp/<exp>/...
  // Cambialo a ogni nuovo test (t01, t02, ...) così non si mischiano per cache.
  exp: "t04",
};

// Riconosce le chiamate FreeWheel SSP (ad request).
export function fwsspIsTarget(url: string): boolean {
  return typeof url === "string" && url.indexOf(".v.fwmrm.net") !== -1 && url.indexOf("/ad/g/") !== -1;
}

// È un evento/bid di fwssp?
export function isFwssp(o: any): boolean {
  return !!o && (o.bidderCode === "fwssp" || o.bidder === "fwssp");
}

// Normalizza una stringa in chiave Firebase-safe.
export function safeKey(s: any): string {
  return String(s == null ? "na" : s).replace(/[^A-Za-z0-9_-]+/g, "_").slice(0, 40);
}
